/**
 * Remembers that an account was created but never verified.
 *
 * By the time the code screen is reached the SSO account already exists and is
 * unverified. Without this, closing the window stranded it: coming back to
 * /register only offered a password prompt the account could never satisfy, and
 * nothing could reach a resend. Storage is per-origin, so one hub's pending
 * verification is never offered on another.
 */
const KEY = 'pending_email_verification';

// SSO's codes are short-lived. Past this a stored address is likelier to
// confuse a returning visitor than to help them, so it stops being offered.
const MAX_AGE_MS = 60 * 60 * 1000;

export function rememberPendingVerification(email) {
    if (!email) return;

    try {
        localStorage.setItem(KEY, JSON.stringify({ email, at: Date.now() }));
    } catch (e) {
        // Storage unavailable (private browsing, blocked cookies) — resuming is
        // a convenience, so losing it must not break the step itself.
    }
}

export function readPendingVerification() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;

        const { email, at } = JSON.parse(raw);

        if (!email || !at || Date.now() - at > MAX_AGE_MS) {
            clearPendingVerification();
            return null;
        }

        return email;
    } catch (e) {
        return null;
    }
}

export function clearPendingVerification() {
    try {
        localStorage.removeItem(KEY);
    } catch (e) {
        // As above.
    }
}
